import axios from "axios";
import { OutputBaseProps } from "utils/types/API";
import { MenuTreeItemProps } from "apis/menu";
type ApiAuthMenuOutputProps = OutputBaseProps<MenuTreeItemProps[]>
export const apiAuthMenu = async () => {
    const res = (await axios.get<ApiAuthMenuOutputProps>(`/api/auth/my-menu`))
        .data;
    return res;
};
